import React from "react";
// Route hooks resolve to the embedded flow's synthetic location when this page
// is rendered inside a panel, and to the real router otherwise.
import {
  useRouteParams as useParams,
  useRouteLocation as useLocation,
  useIsEmbeddedRoute,
} from "../../../../../common/embeddedFlow/embeddedRoute";
import ProfileCard from "../../../../../common/ProfileCard/ProfileCard";
import DietPlanTab from "./DietPlanTab";

/**
 * Standalone page for viewing/editing a single user's diet plan.
 * Matches the pattern used for templates: list → click row → dedicated detail page.
 */
const DietPlanDetailPage = () => {
  const { id: userId, planId } = useParams();
  const location = useLocation();
  // Inside a panel the host already shows a compact profile header, so the
  // full card here would be a second copy of the same facts.
  const isEmbedded = useIsEmbeddedRoute();

  const planMetaFromState = location.state?.planMeta;

  return (
    <div className="flex-1 flex flex-col items-center">
      <div className="container px-2 py-4 mx-auto overflow-auto w-full">
        {!isEmbedded && (
          <ProfileCard profileId={userId} enableNotesTab />
        )}
        <div className={isEmbedded ? "" : "mt-4"}>
          <DietPlanTab
            profileId={userId}
            planId={planId}
            initialPlanMeta={planMetaFromState}
          />
        </div>
      </div>
    </div>
  );
};

export default DietPlanDetailPage;
